import { render, staticRenderFns } from "./ImgPreviewContent.vue?vue&type=template&id=2af5bd81&scoped=true&"
import script from "./ImgPreviewContent.vue?vue&type=script&lang=js&"
export * from "./ImgPreviewContent.vue?vue&type=script&lang=js&"
import style0 from "./ImgPreviewContent.vue?vue&type=style&index=0&id=2af5bd81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5bd81",
  null
  
)

export default component.exports